// src/components/SectionOne/SectionOne.js
import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import ReactECharts from "echarts-for-react";
import DeckGL from 'deck.gl';
import { Map } from 'react-map-gl';
import "./Contexto.css";
import { GeoJsonLayer } from '@deck.gl/layers';
import { env } from "echarts";
import { useEffect, useState } from "react";
import CollapsibleCitation from "../tools/CollapsibleCitation";
import InformationPopUp from "../tools/InformationPopUp";
export default function Contexto() {
  const mapContainerClass = "map-container";
  const makeRasterStyle = (urlTemplate, attribution = "") => ({
    version: 8,
    sources: {
      rastertiles: {
        type: "raster",
        tiles: [urlTemplate],
        tileSize: 256,
        attribution,
      },
    },
    layers: [
      {
        id: "rastertiles",
        type: "raster",
        source: "rastertiles",
      },
    ],
  });
  const [styleKey, setStyleKey] = useState("Satélite");
  const BASEMAPS = {
    "Satélite": "https://raw.githubusercontent.com/go2garret/maps/main/src/assets/json/arcgis_hybrid.json",
    "Modo Claro": makeRasterStyle(
      "https://basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png",
      '© OpenStreetMap contributors © CARTO'
    ),
    "Modo Oscuro": makeRasterStyle(
      "https://basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}.png",
      '© OpenStreetMap contributors © CARTO'
    ),
     "Calles": makeRasterStyle(
      "https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png",
      '© OpenStreetMap contributors © CARTO'
    ),
    "Open Street Map": makeRasterStyle(
      "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
      '© OpenStreetMap contributors'
    )
  };

  const [populationData, setPopulationData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/data/csv/population.csv")
      .then((response) => response.text())
      .then((csvText) => {
        const lines = csvText.trim().split("\n");
        const data = lines.slice(1).map(line => {
          const [time_period, population] = line.split(",");
          return { time_period, population: parseFloat(population) };
        });
        setPopulationData(data);
        setLoading(false);
      });
  }, []);

  const chartOptions1 = {
   /*  title: {
      text: "Crecimiento Poblacional (2000 a 2020, número de personas)",
      top: 0,
    }, */
    grid: { left: '0%', containLabel: true, right: '15%' },
    tooltip: {},
    xAxis: {
      type: "category",
      data: populationData.map(d => d.time_period),
      name: 'Año',
    },
    yAxis: {
      type: "value",
      name: 'Población',
    },
    series: [{
      data: populationData.map(d => Number(d.population.toFixed(0))),
      type: "line"
    }],
  };

  const [builtAreaData, setBuiltAreaData] = useState([]);
  const [loadingBuiltArea, setLoadingBuiltArea] = useState(true);

  useEffect(() => {
    fetch("/data/csv/built_area.csv")
      .then((response) => response.text())
      .then((csvText) => {
        const lines = csvText.trim().split("\n");
        const data = lines.slice(1).map(line => {
          const [time_period, settlements] = line.split(",");
          return { time_period, settlements: parseFloat(settlements) };
        });
        setBuiltAreaData(data);
        setLoadingBuiltArea(false);
      });
  }, []);

  const chartOptions2 = {
    /* title: {
      text: "Superficie Urbanizada (2000 a 2020, km²)",
      top: 0,
    }, */
    tooltip: {},
    grid: { left: '5%', containLabel: true, right: '15%' },
    xAxis: {
      type: "category",
      data: builtAreaData.map(d => d.time_period),
      name: 'Año',
    },
    yAxis: {
      type: "value",
      name: 'Área (km²)'
    },
    series: [{
      data: builtAreaData.map(d => Number((d.settlements.toFixed(2)/100).toFixed(2))), // Convert m² to km²
      type: "line"
    }],
  };

  // Reference the entire section to detect when it’s in view
  const sectionRef = useRef(null);

  // useInView returns true when the element is sufficiently in the viewport
  const isInView = useInView(sectionRef, {
    amount: 0.5, // how much of the element should be in view to trigger
    once: false,  // whether it should only animate once
  });

    // GeoJsonLayer for DeckGL

    // Example GeoJSON data (replace with your own)
    

    const geoJsonLayer = new GeoJsonLayer({
      id: 'geojson-layer',
      data: "/data/geojson/coronel_portillo.geojson", // Path to your GeoJSON file
      filled: true,
      getFillColor: [34, 139, 34, 77],
      getLineColor: [34, 139, 34, 255],
      lineWidthMinPixels: 1,
      stroked: true,
      pickable: false,
    });

    return (
      <motion.div
        ref={sectionRef}
        className="h-full w-full snap-start grid grid-cols-3 gap-6 bg-white"
        style={{ aspectRatio: "16/9" }}
        // We can animate this entire container
        initial={{ opacity: 0, y: 20 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1 }}
      >
        {/* Left Column - Text Content */}
        <div className="col-span-1 flex flex-col justify-center gap-2 px-4  overflow-y-auto mt-[-5dvh]">
          <motion.h1
            className="text-5xl font-bold text-[#324130] mt-10"
            // Each sub-element can have its own animation
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 0.2 }}
          >
            Coronel Portillo 
            <InformationPopUp 
            title="Región de Análisis"
            description="Este mapa muestra la región de análisis utilizada para generar todas las gráficas y estadísticas. Se obtiene a partir de las fronteras de la zona metropolitana, aplicando un buffer de 10 km alrededor de estas para incluir zonas periféricas." 
            color="324130" 
            color_citation="#000"
            />
            
          </motion.h1>

          <motion.h2
            className="text-3xl text-[#92843B] mt-[-2]"
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 0.4 }}
          >
            Pucallpa
            
          </motion.h2>

          <motion.p
            className="text-justify text-xs leading-relaxed"
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 0.6 }}

          >
            <strong>Coronel Portillo</strong>, ubicada en el <strong>departamento de Ucayali (Perú)</strong>, es una <strong>provincia amazónica de escala intermedia</strong>, caracterizada por una <strong>urbanización dispersa</strong> y una <strong>dinámica de crecimiento poblacional moderada (2.4% anual)</strong>. Su capital, <strong>Pucallpa</strong>, concentra el <strong>grueso de la población</strong> —con <strong>466,369 habitantes</strong>— y se constituye como un <strong>nodo económico y logístico estratégico</strong> para la región, articulado por <strong>conectividad fluvial (río Ucayali)</strong> y <strong>terrestre</strong>.
            <br />
            <br />
La <strong>densidad urbana</strong> es relativamente <strong>baja (12.67 hab/km²)</strong>, y la <strong>huella urbana</strong> se distribuye principalmente en <strong>áreas suburbanas (23 km²)</strong> y <strong>centro urbano consolidado (57 km²)</strong>, sin presencia de <strong>clústeres densos o semidensos</strong>. Esta <strong>configuración territorial</strong>, en la <strong>frontera ecológica de la Amazonía</strong>, presenta <strong>condiciones sensibles</strong> para el <strong>monitoreo de emisiones derivadas de cambios en el uso de suelo</strong>.
            <br />
            <br />
Los <strong>datos satelitales</strong> muestran <strong>patrones de deforestación</strong> en las <strong>zonas periurbanas de Pucallpa</strong>, lo que destaca la necesidad de <strong>integrar la gestión territorial</strong> con <strong>estrategias de conservación</strong>, especialmente en <strong>zonas de expansión urbana</strong> y <strong>bordes rurales</strong>.
            <br />
            <br />
            <strong>Experimentando Caminos</strong> es una <strong>acción estratégica</strong> del <strong>Foro de Ciudades Amazónicas</strong> que busca apoyar la <strong>adaptación y mitigación del cambio climático</strong> en la <strong>región amazónica</strong>, mediante la <strong>prueba de soluciones creativas y viables</strong>, que puedan ser <strong>efectivas, escalables y replicables</strong>. La iniciativa es implementada por <strong>Geoadaptive</strong>, con el <strong>apoyo técnico y financiero</strong> del <strong>Banco Interamericano de Desarrollo (BID)</strong>, en el marco del <strong>programa Amazonía Siempre</strong>. También cuenta con el <strong>apoyo técnico</strong> del <strong>Cities Lab</strong> del BID y del <strong>Tecnológico de Monterrey</strong>.

          </motion.p>
        </div>

        {/* Right Column - Map and Charts */}
        <div className="col-span-2 flex flex-col justify-center items-center gap-4 px-20">
          <motion.div
            className={`${mapContainerClass} relative w-full h-[40%] rounded-xl shadow-lg mt-5 `}
            style={{ aspectRatio: "16/9" }}
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 0.8 }}
          >
            <div className="absolute left-3 top-3 z-10 text-black">
            <select
              value={styleKey}
              onChange={(e) => setStyleKey(e.target.value)}
              className="bg-white/90 backdrop-blur px-3 py-1.5 rounded-md text-sm shadow border border-black/10"
            >
              {Object.keys(BASEMAPS).map((k) => (
                <option key={k} value={k}>
                  {k}
                </option>
              ))}
            </select>
          </div>

              <DeckGL
                initialViewState={{
                  latitude: -8.3779,
                  longitude: -74.5743,
                  zoom: 10,
                  pitch: 0,
                  bearing: 0,
                }}
                controller={false}
                layers={[geoJsonLayer]}
              >
                <Map
                  mapStyle={BASEMAPS[styleKey]}
                  className="w-full"
                  attributionControl={false}
                />
              </DeckGL>
          </motion.div>

          <motion.div
            className="flex justify-between w-full gap-4"
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 1 }}
          >
            <div className="w-1/2" style={{ aspectRatio: "16/9" }}>
            <motion.h3
              className="text-xl font-semibold"
              initial={{ opacity: 0, y: -10 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Crecimiento Poblacional
              <InformationPopUp
                title="Crecimiento Poblacional"
                description="Esta gráfica muestra el crecimiento poblacional en Coronel Portillo desde el año 2000 hasta 2020, con datos de población por año."
                color="324130"
                title_citation="Crecimiento Poblacional"
                source="GHS POP"
                fullCitation="Carioli, A., Schiavina, M., Freire, S., y MacManus, K. (2023). GHS-POP R2023A: GHS population grid multitemporal (1975–2030) [Conjunto de datos]. European Commission, Joint Research Centre (JRC). https://doi.org/10.2905/2FF68A52-5B5B-4A22-8F40-C41DA8332CFE"
                color_citation="000"
              />
            </motion.h3>
              <ReactECharts option={chartOptions1} className="w-full h-full mt-[0%]" />
              

            </div>
            <div className="w-1/2" style={{ aspectRatio: "16/9" }}>
            <motion.h3
              className="text-xl font-semibold"
              initial={{ opacity: 0, y: -10 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              Superficie Urbanizada
              <InformationPopUp
                title="Superficie Urbanizada"
                description="Esta gráfica muestra el cambio de superficie urbanizada por quinquenio, desde 2000 hasta 2020. Se define como “superficie urbanizada” a toda superficie cubierta por estructuras artificiales creadas por el ser humano."
                color="324130" 
                 source="GHS BUILT"
                fullCitation="Pesaresi, M. y Politis, P. (2023). GHS-BUILT-S R2023A: GHS built-up surface grid, derived from Sentinel-2 composite and Landsat, multitemporal (1975–2030) [Conjunto de datos]. Comisión Europea, Centro Común de Investigación (JRC). https://doi.org/10.2905/9F06F36F-4B11-47EC-ABB0-4F8B7B1D72EA"
                color_citation="#000"
              />
            </motion.h3>
              <ReactECharts option={chartOptions2} className="w-full h-full mt-[0%]" />
              
              
            </div>
          </motion.div>
        </div>
      </motion.div>
    );
}